// This icon file is generated automatically.
var PDownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.81 3h-1.17a.25.25 0 00-.2.1L6 9.22 1.56 3.1a.25.25 0 00-.2-.1H.19c-.1 0-.16.12-.1.2l5.5 7.6c.2.27.61.27.81 0l5.51-7.6c.06-.08 0-.2-.1-.2z", "fill-rule": "nonzero" } }] }, "name": "p-down", "theme": "outlined" };
export default PDownOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDownOutlined.js
// module id = 3347
// module chunks = 0